export class UnknownProviderError extends Error {
	constructor(public cause: any) {
		super('Unknown provider error occurred');
		this.name = 'UnknownProviderError';
	}
}
